import { useEffect } from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import { MainLayout } from "../Layout/MainLayout";
import { ErrorPage } from "../Pages/ErrorPage";
import PrivacyPoliciesPage from "../Pages/PrivacyPoliciesPage/PrivacyPoliciesPage";
import { Registro } from "../Modules/ResiduosSolidos/Pages/Registro";

export const AppRouter = () => {
  // const { isAuth, getUser } = useUser();

  // const NoAuthenticatedRoute = ({ children, redirectTo }) => {
  //   const { key: keyLocation } = useLocation();
  //   const isInitialLocation = keyLocation === "default";
  //   const to = isInitialLocation ? "/" : -1;

  //   return isAuth() ? <Navigate to={to} /> : children;
  // };

  return (
    <HashRouter>
      <Routes>
        <Route path="" element={<MainLayout />}>
          <Route index element={<Registro />} />
        </Route>
        <Route path="politicas" element={<PrivacyPoliciesPage />} />
        <Route path="terminos" element={<PrivacyPoliciesPage />} />
        <Route path="*" element={<ErrorPage></ErrorPage>} />
      </Routes>
    </HashRouter>
  );
};
